import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-logo">
            <h2>SWITCH</h2>
            <p>Your everyday App</p>
          </div>
          <div className="app-buttons">
            <button className="app-button apple">
              <img src="/assets/images/apple-logo.png" alt="App Store" />
              App Store
            </button>
            <button className="app-button google">
              <img src="/assets/images/google-play.png" alt="Google Play" />
              Google Play
            </button>
          </div>
        </div>
        
        <div className="footer-middle">
          <p className="address">
            281 Herbert Macaulay Wy, Central Business District,<br />
            Federal Capital Territory.
          </p>
          
          <div className="social-links">
            <p>Follow us:</p>
            <div className="social-icons">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <i className="icon-twitter">X</i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <i className="icon-instagram">IG</i>
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer">
                <i className="icon-tiktok">TK</i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <i className="icon-facebook">F</i>
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="links">
            <Link to="/terms">Terms and Policies</Link>
            <span className="separator">•</span>
            <Link to="/privacy">Privacy Notice</Link>
          </div>
          <p className="copyright">
            © Copyright: Switch 2021 - 2025
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 